export default "https://cdn-static.gokick.com/assets/4e3548e0bbc963e39203d4ae4090204efad0894d/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";